/* Romhatten 2026 – små forbedringer oven på Horizon. */

/* Nedtælling til næste udgivelse (sektionen "Romhatten: venteliste"). Skjules når tidspunktet er passeret. */
(function () {
  function tick() {
    document.querySelectorAll('.rh-countdown[data-release]').forEach(function (el) {
      var target = Date.parse(el.dataset.release);
      var out = el.querySelector('[data-countdown-time]');
      if (isNaN(target) || !out) { el.hidden = true; return; }
      var s = Math.floor((target - Date.now()) / 1000);
      if (s <= 0) { el.hidden = true; return; }
      var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      out.textContent = (d ? d + ' d · ' : '') + String(h).padStart(2, '0') + ' t · ' + String(m).padStart(2, '0') + ' m · ' + String(sec).padStart(2, '0') + ' s';
    });
  }
  tick();
  setInterval(tick, 1000);
})();

/* Nyhedsbrevs-popup (sektionen "Romhatten: popup"). Åbner efter data-delay sekunder eller ved exit-intent
   på PC. Lukket: vises ikke igen i data-days dage. Tilmeldt (her eller i en anden tilmeldingsboks):
   vises aldrig igen. Efter indsendelse genindlæser Shopify siden – så åbnes popuppen med svaret. */
(function () {
  var d = document.getElementById('rh-popup');
  if (!d) return;
  var KEY = 'rh_popup';
  function get() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
  function set(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function open() {
    if (d.open || document.querySelector('dialog[open]:not(#rh-popup)')) return;
    if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
  }
  function dismiss() {
    if (!get().done) set({ until: Date.now() + (parseInt(d.dataset.days, 10) || 30) * 864e5 });
    if (d.open && d.close) d.close(); else d.removeAttribute('open');
  }
  d.querySelectorAll('[data-rh-popup-close]').forEach(function (b) { b.addEventListener('click', dismiss); });
  d.addEventListener('click', function (e) { if (e.target === d) dismiss(); });
  d.addEventListener('cancel', function (e) { e.preventDefault(); dismiss(); });
  // Giv frigivelses-popuppen besked, når denne popup lukkes (den venter på os)
  d.addEventListener('close', function () { document.dispatchEvent(new CustomEvent('rh:newsletter-popup-closed')); });

  if (d.hasAttribute('data-design-mode')) {
    document.addEventListener('shopify:section:select', function (e) { if (d.closest('.shopify-section') === e.target) open(); });
    document.addEventListener('shopify:section:deselect', function (e) { if (d.closest('.shopify-section') === e.target && d.open) d.close(); });
    return;
  }
  if (d.querySelector('.rh-waitlist-form__success')) { set({ done: 1 }); open(); return; }
  if (d.querySelector('.rh-waitlist-form__error')) { open(); return; }
  if (document.querySelector('.rh-waitlist-form__success')) { set({ done: 1 }); return; }

  var st = get();
  if (st.done || (st.until && st.until > Date.now())) return;
  window.rhNewsletterPending = true; // frigivelses-popuppen venter, til denne er lukket
  setTimeout(open, (parseInt(d.dataset.delay, 10) || 20) * 1000);
  if (window.matchMedia && window.matchMedia('(pointer: fine)').matches) {
    document.addEventListener('mouseout', function onOut(e) {
      if (!e.relatedTarget && e.clientY <= 0) { document.removeEventListener('mouseout', onOut); open(); }
    });
  }
})();

/* Produktvideoer: galleriet er kvadratisk, så videoer vises i en lightbox i deres eget format,
   med lyd og kontrolknapper. Horizon indlæser og starter videoen som normalt ved klik; i samme
   øjeblik den begynder at spille i galleriet, pauses den dér og afspilles i lightboxen i stedet
   (stadig inden for kundens klik, så browseren tillader lyd). */
(function () {
  var dialog;

  function getDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'rh-video-dialog';
    dialog.setAttribute('aria-label', 'Video');
    dialog.innerHTML =
      '<button type="button" class="rh-video-dialog__close" aria-label="Luk video">&times;</button>' +
      '<div class="rh-video-dialog__stage"></div>';
    document.body.appendChild(dialog);
    dialog.querySelector('.rh-video-dialog__close').addEventListener('click', function () {
      dialog.close();
    });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog || e.target.classList.contains('rh-video-dialog__stage')) dialog.close();
    });
    dialog.addEventListener('close', function () {
      var stage = dialog.querySelector('.rh-video-dialog__stage');
      var v = stage.querySelector('video');
      if (v) v.pause();
      stage.innerHTML = '';
    });
    return dialog;
  }

  function openLightbox(galleryVideo) {
    var d = getDialog();
    var stage = d.querySelector('.rh-video-dialog__stage');
    var video = galleryVideo.cloneNode(true);
    video.removeAttribute('autoplay');
    video.removeAttribute('muted');
    video.muted = false;
    video.controls = true;
    video.setAttribute('playsinline', '');
    stage.innerHTML = '';
    stage.appendChild(video);
    if (!d.open) d.showModal();
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
    video.addEventListener('ended', function () { d.close(); }, { once: true });
  }

  document.addEventListener(
    'play',
    function (e) {
      var video = e.target;
      if (!video || video.tagName !== 'VIDEO') return;
      if (video.closest('.rh-video-dialog')) return;
      if (!video.closest('.product-media-container--video')) return;
      video.pause();
      openLightbox(video);
    },
    true
  );
})();

/* Salgsstart (felt "Salgsstart" på produktet): nedtælling på produktsiden og i banneret over menuen.
   data-release-ts = salgsstart i sekunder (unix). data-on-end:
   - "reload": produktsiden genindlæses med en ny URL (uden cache), så købsknappen kommer frem.
     Viser siden stadig "før salgsstart" (fx forkert ur på computeren), prøves igen hvert 10. sekund.
   - "live": banneret skifter til "Salget er i gang" og skjules ved data-end-ts.
   - "card": produktkort/mega-menu skifter til "Til salg nu".
   Elementer, der indsættes senere (fx mega-menuen, som indlæses ved hover), startes automatisk. */
(function () {
  var opening = document.querySelector('[data-rh-opening]');

  function freshUrl() {
    var u = new URL(location.href);
    u.searchParams.set('rh', Date.now().toString(36));
    return u.toString();
  }
  function reloadSoon(ms) {
    setTimeout(function () { location.replace(freshUrl()); }, ms);
  }
  function pad(n) { return String(n).padStart(2, '0'); }

  if (opening) reloadSoon(15000);

  function setup(el) {
    if (el.dataset.rhInit) return;
    el.dataset.rhInit = '1';
    var release = parseInt(el.dataset.releaseTs, 10) * 1000;
    var end = parseInt(el.dataset.endTs || '0', 10) * 1000;
    var action = el.dataset.onEnd;
    var out = {
      d: el.querySelector('[data-d]'),
      h: el.querySelector('[data-h]'),
      m: el.querySelector('[data-m]'),
      s: el.querySelector('[data-s]')
    };
    if (!release) return;

    // Allerede passeret ved indlæsning, men siden er stadig "før salgsstart": vent lidt og prøv igen.
    if (action === 'reload' && release <= Date.now()) {
      var msg = el.querySelector('[data-opening]');
      if (msg) msg.hidden = false;
      reloadSoon(10000);
      return;
    }

    var timer;
    function tick() {
      var now = Date.now();
      var left = Math.max(0, Math.floor((release - now) / 1000));
      if (out.d) out.d.textContent = Math.floor(left / 86400);
      if (out.h) out.h.textContent = pad(Math.floor((left % 86400) / 3600));
      if (out.m) out.m.textContent = pad(Math.floor((left % 3600) / 60));
      if (out.s) out.s.textContent = pad(left % 60);
      if (left > 0) return;

      if (action === 'reload') {
        clearInterval(timer);
        var msg = el.querySelector('[data-opening]');
        if (msg) msg.hidden = false;
        reloadSoon(300 + Math.floor(Math.random() * 1500));
      } else if (action === 'live' || action === 'card') {
        el.classList.add('is-live');
        if (end && now >= end) {
          clearInterval(timer);
          el.hidden = true;
        }
      }
    }
    tick();
    timer = setInterval(tick, 1000);
  }

  function scan(root) {
    if (root.matches && root.matches('[data-rh-countdown]')) setup(root);
    if (root.querySelectorAll) root.querySelectorAll('[data-rh-countdown]').forEach(setup);
  }
  scan(document);
  new MutationObserver(function (records) {
    records.forEach(function (r) {
      r.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Frigivelses-popup (sektionen "Romhatten: frigiv-popup"). Venter på nyhedsbrevs-popuppen, hvis den skal vises
   (data-after sek. efter den er lukket), ellers data-delay sek. Lukket: ikke igen i data-days dage for den samme
   frigivelse (data-key = produkt + tidspunkt). Er en anden dialog åben, prøves igen lidt senere. */
(function () {
  var d = document.getElementById('rh-release-popup');
  if (!d) return;
  var KEY = 'rh_release_popup';
  function get() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
  function set(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function open() {
    if (d.open) return;
    if (document.querySelector('dialog[open]')) { setTimeout(open, 5000); return; }
    if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
  }
  function dismiss() {
    set({ key: d.dataset.key, until: Date.now() + (parseInt(d.dataset.days, 10) || 2) * 864e5 });
    if (d.open && d.close) d.close(); else d.removeAttribute('open');
  }
  d.querySelectorAll('[data-rh-release-close]').forEach(function (b) { b.addEventListener('click', dismiss); });
  d.addEventListener('click', function (e) { if (e.target === d) dismiss(); });
  d.addEventListener('cancel', function (e) { e.preventDefault(); dismiss(); });
  var cta = d.querySelector('.rh-rp__cta');
  if (cta) cta.addEventListener('click', function () { set({ key: d.dataset.key, until: Date.now() + (parseInt(d.dataset.days, 10) || 2) * 864e5 }); });

  if (d.hasAttribute('data-design-mode')) {
    document.addEventListener('shopify:section:select', function (e) { if (d.closest('.shopify-section') === e.target) open(); });
    document.addEventListener('shopify:section:deselect', function (e) { if (d.closest('.shopify-section') === e.target && d.open) d.close(); });
    return;
  }
  var st = get();
  if (st.key === d.dataset.key && st.until && st.until > Date.now()) return;
  if (window.rhNewsletterPending) {
    document.addEventListener('rh:newsletter-popup-closed', function () {
      setTimeout(open, (parseInt(d.dataset.after, 10) || 8) * 1000);
    }, { once: true });
  } else {
    setTimeout(open, (parseInt(d.dataset.delay, 10) || 12) * 1000);
  }
})();
